module.exports = __webpack_public_path__ + "static/media/alyssa.2e4fe80e.jpg";